// extracted by mini-css-extract-plugin
export default {"container":"dia_2Mi30","fullscreen":"dia_ful_34YZU","closeButton":"dia_clo_26St7"};